import PageHeaderBlock from '@layouts/PageHeaderBlock';

const AboutUs: React.FC = () => {
  return (
    <>
      <PageHeaderBlock title="About Us" />
    </>
  );
};

AboutUs.displayName = 'AboutUs';

export default AboutUs;
